import React from 'react';
import { AdT } from 'src/ads/types';

export const AdSlot = (props: { ad: AdT }) => {
  window._aeq = window._aeq || [];

  // Request the slot on component mounting and destroy it on unmounting
  React.useEffect(() => {
    window._aeq.push(['getAdTag', {
      containerId: `st-pos-${props.ad.position}`,
      orientation: 'hor',
      index: props.ad.position,
    }]);

    return () => {
        window._aeq.push(['destroy', `st-pos-${props.ad.position}`]);
    };
  },[]);

  return React.createElement(
      'nd-ad-slot',
      {id: `nd-ad-slot-st-pos-${props.ad.position}`,},
      React.createElement('div', {id: `st-pos-${props.ad.position}`}),
  );
};
